import { IconType } from 'components/DesignSystem/Icon/icons';

export type ProductCardEntry = {
  id: string;
  name: string;
  link: string;
  product: string;
  subproduct: string;
  description?: string;
  icon?: IconType;
};

export const fluxProductsList: ProductCardEntry[] = [
  {
    name: 'Upload', link: '/flux/upload', product: 'flux', subproduct: 'upload', id: 'upload', icon: 'upload',
  },
  {
    name: 'Personalizado', link: '/flux/personalized', product: 'flux', subproduct: 'personalizado', id: 'personalized', icon: 'edit',
  },
  {
    name: 'Automático', link: '/flux/automatic/classic', product: 'flux', subproduct: 'automatico', id: 'automatic', icon: 'refresh',
  },
  {
    name: 'Sobre', link: '/flux/about', product: 'flux', subproduct: 'sobre', id: 'about', icon: 'info',
  },
  {
    name: 'Tutorial', link: '/flux/videos/categories', product: 'flux', subproduct: 'tutoriais', id: 'videos', icon: 'help',
  },
];

export const windxProductsList: ProductCardEntry[] = [
  {
    name: 'Automático', link: '/windx/automatic', product: 'windx', subproduct: 'automatico', id: 'automatic', icon: 'refresh',
  },
  {
    name: 'Sobre', link: '/windx/about', product: 'windx', subproduct: 'sobre', id: 'about', icon: 'info',
  },
];

export const meteorologyProductsList: ProductCardEntry[] = [
  {
    name: 'Videos', link: '/meteorology/videos/categories', product: 'meteorologia', subproduct: 'videos', id: 'videos', icon: 'video',
  },
  {
    name: 'Mapas e meteogramas', link: '/meteorology/fields/observeddata', product: 'meteorologia', subproduct: 'mapas-meteogramas', id: 'maps', icon: 'layers',
  },
  {
    name: 'Clima', link: '/meteorology/weather/oscillations/', product: 'meteorologia', subproduct: 'clima', id: 'weather', icon: 'wind',
  },
  {
    name: 'Agrometeorologia', link: '/agro/overview', product: 'meteorologia', subproduct: 'agro', id: 'agro', icon: 'sprout',
  },
  {
    name: 'Tutorial', link: '/meteorology/tutorial/categories', product: 'meteorologia', subproduct: 'tutorial', id: 'tutorial', icon: 'help',
  },
];

export const relatoriosProductsList: ProductCardEntry[] = [
  {
    name: 'Informe Diário', link: '/relatorios/decomp', product: 'relatorios', subproduct: 'diario', id: 'diario', icon: 'time',
  },
  {
    name: 'Informe Intersemanal', link: '/relatorios/intersemanal', product: 'relatorios', subproduct: 'intersemanal', id: 'intersemanal', icon: 'line_axis',
  },
  {
    name: 'Informe Semanal', link: '/relatorios/semanal', product: 'relatorios', subproduct: 'semanal', id: 'semanal', icon: 'calendar',
  },
  {
    name: 'Informe Mensal', link: '/relatorios/mensal', product: 'relatorios', subproduct: 'mensal', id: 'mensal', icon: 'table_rows',
  },
];

export const adminProductList: ProductCardEntry[] = [
  {
    name: 'Usuários', link: '/admin/users', product: 'admin', subproduct: 'usuarios', description: 'Criar, editar e gerenciar usuários.', id: 'users', icon: 'user',
  },
  {
    name: 'Empresas', link: '/admin/companies', product: 'admin', subproduct: 'empresas', description: 'Criar, editar e gerenciar empresas e contratos.', id: 'companies', icon: 'stack',
  },
  {
    name: 'Financeiro', link: '/admin/financial', product: 'admin', subproduct: 'financeiro', description: 'Envio de arquivos para fins financeiros.', id: 'financial', icon: 'upload',
  },
  {
    name: 'Mailer', link: '/admin/mailer/reports', product: 'admin', subproduct: 'mailer', description: 'Envio de relatórios e e-mails em massa.', id: 'mailer', icon: 'paper_plane',
  },
  {
    name: 'Administração Flux', link: '/admin/flux/about', product: 'admin', subproduct: 'flux', description: 'Gerenciar documentos e configurações do Flux.', id: 'admin-flux', icon: 'flux',
  },
  {
    name: 'Administração Windx', link: '/admin/windx/models', product: 'admin', subproduct: 'windx', description: 'Gerenciar modelos do painel Windx.', id: 'admin-windx', icon: 'wind',
  },
];
